import { render, staticRenderFns } from "./librosObsequios.vue?vue&type=template&id=65c25792&scoped=true"
import script from "./librosObsequios.vue?vue&type=script&lang=js"
export * from "./librosObsequios.vue?vue&type=script&lang=js"
import style0 from "./librosObsequios.vue?vue&type=style&index=0&id=65c25792&prod&scoped=true&lang=css"
import style1 from "./librosObsequios.vue?vue&type=style&index=1&id=65c25792&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c25792",
  null
  
)

export default component.exports